import React from 'react';
import { type LoaderFunctionArgs, type RouteObject } from 'react-router-dom';
import type { InitialProps } from '../lib/types';
import { ROOT_ROUTE, ROUTES, SHOPIFY } from '../lib/constants/routes';
import { WizardLayout } from './layouts/WizardLayout';
import {
    ChooseBanners,
    ChooseNiche,
    ChooseSellingPlan,
    LinkYourStore,
    InstallApp,
    Subscribe,
    CreateStore,
    AdditionalServices,
    SubscribeAutods,
    Publish,
    SignUp,
} from './steps';
import { QueryProvider } from './providers/QueryProvider';
import { ErrorPage } from './components/error-page/ErrorPage';
import { StepValidationProvider } from './contexts/step-validation/StepValidationContext';

export const routes: RouteObject[] = [
    {
        id: ROOT_ROUTE,
        element: (
            <QueryProvider>
                <StepValidationProvider>
                    <WizardLayout />
                </StepValidationProvider>
            </QueryProvider>
        ),
        loader: (args: LoaderFunctionArgs<InitialProps>) => ({ ...args.context }),
        errorElement: <ErrorPage />,
        shouldRevalidate: () => false,
        path: SHOPIFY,
        children: [
            {
                path: ROUTES.CHOOSE_NICHE,
                element: <ChooseNiche />,
            },
            {
                path: ROUTES.CHOOSE_BANNERS,
                element: <ChooseBanners />,
            },
            {
                path: ROUTES.CHOOSE_SELLING_PLAN,
                element: <ChooseSellingPlan />,
            },
            {
                path: ROUTES.SIGN_UP,
                element: <SignUp />,
            },
            {
                path: ROUTES.LINK_YOUR_STORE,
                element: <LinkYourStore />,
            },
            {
                path: ROUTES.INSTALL_APP,
                element: <InstallApp />,
            },
            {
                path: ROUTES.SUBSCRIBE,
                element: <Subscribe />,
            },
            {
                path: ROUTES.CREATE_STORE,
                element: <CreateStore />,
            },
            {
                path: ROUTES.ADDITIONAL_SERVICES,
                element: <AdditionalServices />,
            },
            {
                path: ROUTES.SUBSCRIBE_AUTODS,
                element: <SubscribeAutods />,
            },
            {
                path: ROUTES.PUBLISH,
                element: <Publish />,
            },
        ],
    },
];
